angular.module('unica_invitation_group.invitation_group_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// INVITATION GROUP
		.state('app.invitation_group', {
			url: '/invitation-group',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/invitation-group/templates/invitation-group.html',
					controller: 'InvitationGroupBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})


			// INVITATION GROUP LIST
			.state('app.invitation_group.list', {
				url: '/list/:event_id',
				views: {
					'invitationGroupContent': {
						templateUrl: './modules/invitation-group/templates/list.html',
						controller: 'InvitationGroupListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Lista Gruppi',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// INVITATION GROUP CREATE
			.state('app.invitation_group.create', {
				url: '/create/:event_id',
				views: {
					'invitationGroupContent': {
						templateUrl: './modules/invitation-group/templates/create.html',
						controller: 'InvitationGroupCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Gruppo',
					parent: 'app.invitation_group.list'
				}
			})

			// INVITATION GROUP EDIT
			.state('app.invitation_group.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'invitationGroupContent': {
						templateUrl: './modules/invitation-group/templates/edit.html',
						controller: 'InvitationGroupEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Gruppo',
					parent: 'app.invitation_group.list'
				}
			})

			// INVITATION GROUP ASSIGN
			.state('app.invitation_group.assign', {
				url: '/assign/:event_id/:id',
				views: {
					'invitationGroupContent': {
						templateUrl: './modules/invitation-group/templates/assign.html',
						controller: 'InvitationGroupAssignController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Seleziona Componenti',
					parent: 'app.invitation_group.list'
				}
			})
	;


});
